import { useId } from 'react'

import { IconMat } from '@cash-design-system/react'

/**
 * There is no replacement for this in Arcade, should only be used for legacy reasons.
 */
export const MooncakeCVV = () => {
  const clipPath = useId()
  return (
    <IconMat>
      <svg width={32} height={32} fill="none" aria-hidden>
        <g fill="currentColor" clipPath={`url(#${clipPath})`}>
          <path d="m8.305 14.02 1.67-.99c.093-.061.109-.123.063-.216-1.099-1.763-2.769-2.537-4.625-2.537-3.186 0-5.413 2.29-5.413 5.708 0 3.433 2.227 5.737 5.444 5.737 2.119 0 3.666-1.005 4.655-2.706.047-.093.016-.17-.062-.217l-1.716-.912c-.078-.047-.17-.031-.217.062-.51.912-1.36 1.593-2.614 1.593-1.825 0-2.938-1.5-2.938-3.558 0-2.041 1.098-3.526 2.923-3.526 1.098 0 1.964.449 2.614 1.5.046.093.139.109.216.062ZM21.038 10.479h-2.35a.2.2 0 0 0-.186.123l-2.444 7.718-2.474-7.718a.201.201 0 0 0-.186-.123h-2.335c-.109 0-.155.062-.124.17l3.805 10.749c.03.093.108.123.185.123h2.258c.078 0 .155-.03.186-.123l3.789-10.75c.031-.107-.015-.17-.124-.17ZM31.867 10.479h-2.35a.201.201 0 0 0-.186.123l-2.444 7.718-2.475-7.718a.2.2 0 0 0-.185-.123H21.89c-.108 0-.154.062-.123.17l3.804 10.749c.031.093.109.123.186.123h2.258c.077 0 .155-.03.186-.123l3.789-10.75c.03-.107-.016-.17-.124-.17Z" />
        </g>
        <defs>
          <clipPath id={clipPath}>
            <path fill="#fff" d="M0 10.278h32v11.445H0z" />
          </clipPath>
        </defs>
      </svg>
    </IconMat>
  )
}
